import z from 'zod'
import { ApiSecretRequiredException } from '../../errors'
import type { FetchSubTypes } from '../../types'
import { createClient } from '../createClient'

export const fetchSubTypes: FetchSubTypes = async ({
  apiKey,
  apiSecret,
  createHeaders,
  proxy,
}) => {
  if (!apiSecret) {
    throw new ApiSecretRequiredException()
  }

  const client = createClient({
    apiKey,
    apiSecret,
    createHeaders,
    proxy,
  })

  const response = await client.run({
    method: 'GET',
    path: '/api/v3/selfSymbols',
    query: {
      permissions: 'SPOT',
      showPermissionSets: 'false',
    },
    responseSchema,
  })

  const subTypes = new Set<string>()
  for (const symbol of response.data) {
    subTypes.add(symbol)
  }

  return [...subTypes].sort((a, b) => a.localeCompare(b))
}

const responseSchema = z.object({
  code: z.union([z.string(), z.number()]),
  data: z.array(z.string()),
})
